import {Lang} from 'yougile-lang'
import {Debouncer, Time, Util} from 'yougile-util'
import {
  DataObjectId,
  Hub,
  StickerStateId,
  StickerType,
  Tag
} from 'yougile-model'
import {Sync} from '../../../client/sync'
import {ChatSubscribers} from '../../chat-subscribers'
import {Task} from '../../task'
import {Sticker} from '../sticker'
import {ASystemStickerCtl} from './a-system-sticker-ctl'

interface StickerState {
  id: StickerStateId
}

type TrackMap = {
  [key: string]: Debouncer<unknown>
}

const delayToSquashRecords = 10000

const trackMap: TrackMap = {}

export class UserCtl<
  T extends StickerState = StickerState
> extends ASystemStickerCtl<DataObjectId> {
  public override get title(): string {
    return 'User'
  }

  public get type(): StickerType {
    return 'user'
  }

  public displayedTitle(_: Tag): string {
    return Lang.msg.assigned
  }

  public override onPin(
    task: Hub,
    _: Tag,
    userIdOrArr: DataObjectId | DataObjectId[]
  ): void {
    const users = getArray(userIdOrArr)

    task.data.assignTime = Time.now()
    Task.commitWithCheckPhantom(task)

    if (!Task.isPhantom(task)) {
      const key = `${task.id}`
      if (!trackMap[key]) {
        trackMap[key] = new Debouncer(delayToSquashRecords)
      }

      // need render after squash in server
      trackMap[key].runLatest(() => {
        trackMap[key] = undefined
        task.data.assignTime++

        task.commit()
      })
    }

    const oldUsers = Sticker.getUsers(task)
    if (oldUsers.length === 0) {
      Task.clearGTDStage(task)
      Task.insertInGTD(task, 'new', 'UserCtl -> onPin')
    }

    if (!Task.isPhantom(task)) {
      const box = Sync.get(task)
      for (const userId of users) {
        if (userId && box.isUserInCompany(userId)) {
          ChatSubscribers.setSubscription(userId, task, true)
        }
      }
    }
  }

  getState(sticker: Tag, id: StickerStateId): T {
    return Util.clone(sticker.states.index[id]) as T
  }
}

const getArray = <T>(value?: T | T[]): T[] => {
  if (Array.isArray(value)) {
    return value
  }
  if (!value) {
    return []
  }
  return [value]
}
